import axios from "axios";
import $ from "jquery";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import defaultImage from "../../assets/svg/defultImage.svg";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";
import { VEHICLE_ASSIGNS, VEHICLES_LIST } from "../../URLs/Apis";

const TransfereStuffModal = ({
  handleTransfereStuffModalClose,
  getVehicleById,
  selectVanModal,
  getStuffVehicle,
  stuffId, 
}) => {

  const { user } = useSelector((state) => state.auth);
  const token = user?.token;
  const [vanList, setVanList] = useState([]);
  const [selectedVanId, setSelectedVanId] = useState("");
  const {id:vanId} = useParams()

  const handleTransfereStuff = async (id) => {
    
    try {
      const response = await axios.get(VEHICLES_LIST, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data);
      setVanList(response.data.data.door_step_vehicles);
    } catch (error) {
      console.log(error);
    }
    
  };
  const handleSelection = (id) => {
    console.log("idddd", id);
    console.log(selectVanModal);
    
    setSelectedVanId(id);
    $(".stuff-card").removeClass("selectedVan");
    $(".stuff-card").removeClass("unSelectedVan");

    $("#" + id).addClass("selectedVan");
  };
  const handleTransfereStuffFromVanToVan = async () => {

    try {
      const response = await axios.post(  
        `${VEHICLE_ASSIGNS}/${vanId}/staffs/transfer`,
        {
          stuff_ids: [stuffId],
          new_vehicle_id: selectedVanId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response);
      toast.success(response.data.data.message);
      handleTransfereStuffModalClose();
      getStuffVehicle();
      getVehicleById()
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.errors?.message);}
  };
  useEffect(() => {
    handleTransfereStuff();
  }, []);

  return (
    <Modal
      show={selectVanModal}
      onHide={handleTransfereStuffModalClose}
      size="xl"
    >
      <Modal.Header style={{ backgroundColor: "#D5D5D5" }}>
        <Modal.Title className="text-black">Select Van</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="container rounded-2 overflow-y-scroll vh-100"
        style={{}}
      >
        <div className="row">
        

          {vanList.map((van) => {
            const getStaffByRole = (slug) => {
  const staff = van?.current_stuff?.find(
    (staff) => staff?.job_title?.slug === slug
  );
  return staff;
};
return(
   <div
      id={van?.id}
      onClick={() => selectVanModal && handleSelection(van.id)}
      style={{ minHeight: 50 }}
      className={`col-12 col-lg-3 col-md-3 ${selectVanModal && "stuff-card"}`}
    >
      <div 
      
      style={
        
        {
        
        overflow: "hidden",
      }} key={van?.id} className="rounded-2 card p-2 bg-light my-2 custom-hight-mobile" >
        <div className="d-flex custom-card-sm align-items-center justify-content-between mt-1 mx-2">
          <div className="d-flex align-items-center gap-1">
            <img style={{ width: 20 }} src={van?.model?.brand?.logo_path? `${newImageUrl}${van?.model?.brand?.logo_path }`: defaultImage} alt="brand-image" />

            <h6 style={{ fontSize: 10, marginInline: 3 }} className="m-0 ">{van?.name}</h6>
          </div>
          <h6 className="fs-6 fw-bold">Van # {van?.id}</h6>
        </div>

  <div className="d-flex custom-card-sm justify-content-center align-items-center custom-hight-img-card mx-4 my-3 ">
                        <img
                          className="img-fluid"
                          src={
                            van?.profile_photo_url
                              ? `${newImageUrl}${van?.profile_photo_url}`
                              : defaultImage
                          }
                          alt="van-image"
                          style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "fill" }}
                        />
                      </div>
        <div className="my-2">
          <div className="upload-file-responsive">
            <h6 className="main-text-color label-van m-0">Van Capacity</h6>
            <div className="progress my-1 " style={{ height: "10px" }}>
              <div
                className={` ${van?.capacity > 7 && van?.capacity <= 10
                    ? "bg-success"
                    : van?.capacity > 3 && van?.capacity < 7
                      ? "bg-warning"
                      : van?.capacity === 0
                        ? "bg-transparent"
                        : van?.capacity > 0 && van?.capacity < 3
                          ? "bg-danger"
                          : ""
                  }`}
                role="progressbar"
                style={{
                  width:
                    van?.capacity === 10
                      ? "100%"
                      : van?.capacity > 7
                        ? "90%"
                        : van?.capacity > 3 &&
                          van?.capacity < 7
                          ? "50%"
                          : van?.capacity > 0 &&
                            van?.capacity < 3
                            ? "30%"
                            : van?.capacity === 0
                              ? "0%"
                              : "",
                }}
                aria-valuenow={van?.capacity}
                aria-valuemin="0"
                aria-valuemax="10"
              ></div>
            </div>
          </div>

          <div className="upload-file-responsive">
            <h6 className="main-text-color label-van m-0">Working hours</h6>
            <div className="progress my-1 " style={{ height: "10px" }}>
              <div
                className={` ${van?.capacity > 7 && van?.capacity <= 10
                    ? "bg-success"
                    : van?.capacity > 3 && van?.capacity < 7
                      ? "bg-warning"
                      : van?.capacity === 0
                        ? "bg-transparent"
                        : van?.capacity > 0 && van?.capacity < 3
                          ? "bg-danger"
                          : ""
                  }`}
                role="progressbar"
                style={{
                  width:
                    van?.capacity === 10
                      ? "100%"
                      : van?.capacity > 7
                        ? "90%"
                        : van?.capacity > 3 &&
                          van?.capacity < 7
                          ? "50%"
                          : van?.capacity > 0 &&
                            van?.capacity < 3
                            ? "30%"
                            : van?.capacity === 0
                              ? "0%"
                              : "",
                }}
                aria-valuenow={van?.capacity}
                aria-valuemin="0"
                aria-valuemax="10"
              ></div>
            </div>
          </div>

          <div className="d-flex custom-card-sm justify-content-between align-items-center mt-3">
            <h6 className="main-text-color label-van m-0">Services Categories</h6>

            <div className="">
              {van.service_categories?.length > 0 ? (
                <>
                  {van.service_categories.map((service) => (
                    <img
                      className="service-icon"
                      src={
                        newImageUrl +
                        service.icon_url
                      }
                      alt="service-icon"
                    />
                  ))}
                </>
              ) : (
                  <div className="">
                                        <p className="m-0 label-van">No Available Services</p>
                                        
                                    </div>
              )}
            </div>
          </div>
          <div className="d-flex custom-card-sm justify-content-between align-items-center my-1">
            <h6 className="main-text-color m-0 label-van">Supervisor</h6>
            {van?.supervisor?.length > 0 ? (
              van.supervisor.map((supervisor) =>
                `${supervisor.first_name}${supervisor.last_name}`
              )
            ) : (
                <div className="">
                                        <p className="m-0 label-van">No Available Supervisor</p>
                                        
                                    </div>
            )}
          </div>
    <div className="d-flex custom-card-sm justify-content-between align-items-center my-1">
      <h6 className="main-text-color m-0 label-van">Driver</h6>
      <h6 className=" m-0 label-van">
        {getStaffByRole("driver")?.name || (
      <div className="">
                                        <p className="m-0 label-van">No Available Driver</p>
                                        
                                    </div>
        )}
      </h6>
    </div>
    
    <div className="d-flex custom-card-sm justify-content-between align-items-center my-1">
      <h6 className="main-text-color m-0 label-van">Technician</h6>
      <h6 className=" m-0 label-van">
        {getStaffByRole("technician")?.name || (
   <div className="">
                                        <p className="m-0 label-van">No Available Technician</p>
                                        
                                    </div>
        )}
      </h6>
    </div>
    
    <div className="d-flex custom-card-sm justify-content-between align-items-center my-1">
      <h6 className="main-text-color m-0 label-van">Engineer</h6>
      <h6 className=" m-0 label-van">
        {getStaffByRole("engineer")?.name || (
      <div className="">
                                        <p className="m-0 label-size">No Available Engineer</p>
                                        
                                    </div>
        )}
      </h6>
    </div>


        </div>
      </div>
    </div>
)
          }

    
          )}
        </div>
      </Modal.Body>
    
          <div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive">
              <button onClick={() => handleTransfereStuffFromVanToVan()} className="btn btn-dark px-5">Save</button>
              <button onClick={() => handleTransfereStuffModalClose()} type="reset"  className="btn btn-light px-5">Cancel</button>
            </div>
    </Modal>
  );
};

export default TransfereStuffModal;
